import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'cert-workforce-add-staff-added-step',
  templateUrl: './workforce-add-staff-added-step.component.html',
  standalone: false,
})
export class WorkforceAddStaffAddedStepComponent {
  @Input() personName = '';
  @Output() returnToRoster = new EventEmitter<void>();
  @Output() addAnother = new EventEmitter<void>();
  @Output() reviewNewStaff = new EventEmitter<void>();
}
